import {
  SearchSuggestionType,
  LinkTrackingData,
} from '../../../../../AnalyticsContext/LinkTracking';
import { SearchThink } from '../../../../icons/outlined/SearchThink';
import {
  SuggestionIcon,
  SuggestionPrimary,
  SuggestionPrimaryLight,
} from '../SuggestionStyles/SuggestionStyles.styles';
import { SuggestionTemplate } from '../SuggestionTemplate/SuggestionTemplate';

export const SearchSuggestion = ({
  term,
  trackingData,
}: {
  term: string;
  trackingData: LinkTrackingData;
}) => (
  <SuggestionTemplate
    trackingData={{ ...trackingData, searchSuggestionType: SearchSuggestionType.TEXT_SEARCH }}
    visual={
      <SuggestionIcon>
        <SearchThink />
      </SuggestionIcon>
    }
    primary={
      <>
        <SuggestionPrimaryLight>Search for</SuggestionPrimaryLight>{' '}
        <SuggestionPrimary>&lsquo;{term}&rsquo;</SuggestionPrimary>
      </>
    }
  />
);
